
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13.43 16.25"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M11.65 16.25H1.77A1.77 1.77 0 0 1 0 14.48v-1a4.37 4.37 0 0 1 .53-2.2 3.12 3.12 0 0 1 .73-.88 7.69 7.69 0 0 1 3.31-1.35c.58-.14.61-.23.61-.36a1.1 1.1 0 0 0-.51-.76A4.77 4.77 0 0 1 3.59 1.6a3.8 3.8 0 0 1 .82-.83A3.82 3.82 0 0 1 9 .77a3.59 3.59 0 0 1 .82.83 4.77 4.77 0 0 1-1.06 6.33 1.12 1.12 0 0 0-.52.76c0 .12 0 .22.61.36a7.64 7.64 0 0 1 3.31 1.34 3 3 0 0 1 .74.88 4.47 4.47 0 0 1 .52 2.2v1a1.78 1.78 0 0 1-1.77 1.78zM6.71 1A2.85 2.85 0 0 0 5 1.57a2.72 2.72 0 0 0-.6.62 3.73 3.73 0 0 0 .88 4.95 2 2 0 0 1 .89 1.55c0 1-1 1.24-1.38 1.33a6.85 6.85 0 0 0-2.9 1.14 2.18 2.18 0 0 0-.51.61 3.53 3.53 0 0 0-.38 1.7v1a.77.77 0 0 0 .77.77h9.88a.77.77 0 0 0 .78-.77v-1a3.42 3.42 0 0 0-.39-1.7 2 2 0 0 0-.5-.61A6.9 6.9 0 0 0 8.63 10c-.42-.09-1.39-.32-1.39-1.33a2 2 0 0 1 .9-1.55A3.73 3.73 0 0 0 9 2.19a2.57 2.57 0 0 0-.61-.62A2.81 2.81 0 0 0 6.71 1z","fill":"#666","data-name":"Layer 1"}})])])
          )
        }
      }
    